module.exports = {
  email: 'g.melios@lse.ac.uk',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/GMelios',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/george-melios-a9b6a01a1',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/georgemelios',
    },
  ],

  navLinks: [
    {
      name: 'About me',
      url: '/#hero',
      noNumber: true,
    },
    {
      name: 'Research',
      url: '/research',
    },
    {
      name: 'Teaching',
      url: '/#teaching',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Consultancy',
      url: '/#consultancy',
    },
    {
      name: 'Media',
      url: '/#media',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
